<div [ngClass]="{'allocation':isAllocationSheet()}" class="assign-material">
    <div class="assignmaterialcontainer">
        <mat-form-field>
            
            <mat-select [formControl]="materialsFormCtrl"
                        [multiple]="true"
                        #materialsSelector>
                <mat-option>
                    <ngx-mat-select-search
                        noEntriesFoundLabel="No results found"
                        placeholderLabel="Find a material..."
                        [formControl]="materialsFilterFormCtrl">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let material of filteredMaterials | async"
                            [value]="material"
                            (click)="addOrRemoveMaterial(material)">
                    {{ material.name }} ({{ material.id}})
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <table class="table table-borderless rows-no-padding">
        <tr *ngFor="let material of materialsFormCtrl?.value" [ngClass]="{'allocation':isAllocationSheet()}" class="table-row">
            <td class="align-middle">
                <i class="fas fa-check-square main-color margin-right-5"></i>
                {{ material.name }}  ({{ material.id}})
            </td>
            <td class="align-middle text-sm-right">
                <input
                    *ngIf="!isAllocationSheet()"
                    class="form-control form-control-sm float-right no-border max-Width80"
                    [(ngModel)]="material.hours"
                    [disabled]="controlDisabled"
                    (blur)="updateAllocatedMaterialsList()"
                    style="max-width: 80px"
                    oninput="(this.value == '' ? this.value = 0 : '')"
                    step=".01"
                    type="number" min="1" max="24" required/>
                <span *ngIf="isAllocationSheet()">{{ material.hours }}</span>
            </td>
            <td class="align-middle">
                <button class="btn btn-sm"
                        *ngIf="!isAllocationSheet()"
                        [disabled]="controlDisabled"
                        (click)="removeItem(material.id)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>

    <button class="btn btn-default"
            *ngIf="!isAllocationSheet()"
            [disabled]="controlDisabled"
            (click)="materialsSelector.open()">
        <i class="fas fa-plus"></i> {{ l('Add') }}
    </button>

    <button class="btn btn-default"
            *ngIf="isAllocationSheet()"
            [disabled]="controlDisabled"
            (click)="edit()">
        <i class="fas fa-edit"></i> {{ l('Edit') }}
    </button>
    <div class="validation-msg" *ngIf="showError() && !anyResourceSelected">{{ l('MinResourceSelectionCriteria') }}</div>
</div>
